var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isNavbarVisible)?_c('div',{staticClass:"footerNavigation"},[_c('div',{staticClass:"tabbedNavigation"},[_c('tabbed-navigation')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }